import React, {useEffect, useState, useRef} from "react";
// import { connect } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import { injectIntl } from "react-intl";
import {useSelector, useDispatch} from "react-redux";
import {fetchorders, submitOrders, saveOrders, fetchTenantUsers, fetchTenantPaymentSettings, getPaymentStatus, initiatePayment, resetPayment, previewPaymentSummary} from "../ordersCrud";
import { getPaymentSummary, mergePaymentPreview, getPaymentPreviewRequestBody } from "../utils/paymentSummary";
import { PaymentTaxBreakdown } from "../components/PaymentTaxBreakdown";
import {isBuyerPriceEditLocked} from "../utils/buyerPriceEdit";
import { getInventoryQty, getInventoryColumnLabel, isExternalBuyer } from "../utils/inventoryDisplay";
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import {cartCountActions} from "../../../../../redux/reducers/cartCount";
import Stripe from "react-stripe-checkout";
import Input from '@material-ui/core/Input';
import axios from 'axios';
import { formatPrMunicipalityForPdf } from "../../../../utils/prMunicipality";
import NumberInput from "../../../../components/NumberInput";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {Select} from "@material-ui/core";
import FilledInput from "@material-ui/core/FilledInput";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import OrderSummary from "../OrderSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
    ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    ListSubheader,
    TextField,
    Collapse,
    Switch
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(20),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
}));

function ConfirmationPage(props) {

    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();

    const dispatch = useDispatch();
    const [orders,setOrders] = useState([]);
    const [currOrder,setCurrOrder] = useState(null);
    const [currOrderStatus,setCurrOrderStatus] = useState(null);
    const [orderFields,setOrderFields] = useState([]);
    const [isOrdersFetched, setIsOrdersFetched] = useState(false)
    const [isCartEmpty, setIsCartEmpty] = useState(false)
    const [messageBO, setMessageBO] = useState("");
    const [openBO, setOpenBO] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [dialogMessage, setDialogMessage] = useState("");
    const [isOrdersValid, setIsOrdersValid] = useState(false)
    const [isAllSubmit, setIsAllSubmit] = useState(false)
    const [isSelectedSubmit, setIsSelectedSubmit] = useState(false)
    const [isOrderSummaryClicked, setIsOderSummaryClicked] = useState(false)
    const [isOrderUpdated, setIsOrderUpdated] = useState(false)
    const [isSubmitCompleted, setIsSubmitCompleted] = useState(false)
    const [clickedOrder, setClickedOrder] = useState({})
    const [defaultDate, setDefaultDate] = useState("");

    const [selectedOrders,setSelectedOrders] = useState([]);
    const [invalidSelectedOrders,setInvalidSelectedOrders] = useState([]);
    const [invoice,setInvoice] = useState(null);

    const pickupRouteFallback = [{ name: 'Pick Up' }];

    const setPickupInvoiceAfterSubmit = (response, ordersToSubmit) => {
        if (response?.data?.shipVia === 'HOME') {
            setInvoice(response.data);
            return;
        }
        const pickupOrder = (ordersToSubmit || []).find((o) => o.shipVia === 'HOME');
        if (!pickupOrder) return;
        setInvoice({
            ...pickupOrder,
            routes: pickupOrder.routes?.length ? pickupOrder.routes : pickupRouteFallback,
        });
    };

    const setPickupInvoiceFromOrder = (order, fields) => {
        const shipVia = fields?.shipVia ?? order?.shipVia;
        if (shipVia !== 'HOME') return;
        setInvoice({
            ...order,
            ...fields,
            shipVia,
            routes: order?.routes?.length ? order.routes : pickupRouteFallback,
        });
    };

    const [openCW, setOpenCW] = useState(false);
    const [catchWeight, setCatchWeight] = useState("")
    const [catchWeightProduct, setCatchWeightProduct] = useState(null)
    const [catchWeightOrder, setCatchWeightOrder] = useState(null)

    const [expanded, setExpanded] = useState("");

    const [tenantUsers, setTenantUsers] = useState([])
    const [userFilter, setUserFilter] = useState(null)

    const [paymentStatusByOrderId, setPaymentStatusByOrderId] = useState({})
    const [paymentLoadingByOrderId, setPaymentLoadingByOrderId] = useState({})
    const [paymentErrorByOrderId, setPaymentErrorByOrderId] = useState({})
    const [payInProgressByOrderId, setPayInProgressByOrderId] = useState({})
    /** Per-order inline alerts below payment buttons (not dialog). Keys: String(orderId) */
    const [paymentInlineByOrderId, setPaymentInlineByOrderId] = useState({})
    const [resetPaymentOrderId, setResetPaymentOrderId] = useState(null)
    const [resetPaymentLoading, setResetPaymentLoading] = useState(false)
    const [onlinePaymentEnabled, setOnlinePaymentEnabled] = useState(false)

    const ordersRef = useRef([])
    const orderFieldsRef = useRef([])
    const paymentRefetchTimersRef = useRef({})
    const paymentStatusByOrderIdRef = useRef({})
    const fetchPaymentStatusRef = useRef(() => {})
    const paymentSuccessHandledOrderIdsRef = useRef(new Set())
    const paymentAutoSubmitFailedShownRef = useRef(new Set())
    const paymentCompletedRetryScheduledRef = useRef(new Set())
    const paymentCancelledQueryRef = useRef(false)
    ordersRef.current = orders
    orderFieldsRef.current = orderFields
    paymentStatusByOrderIdRef.current = paymentStatusByOrderId

    const {user,accessToken} = useSelector(
        ({auth}) => ({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const scheduleOrderPaymentRefetch = (orderId) => {
        if (!onlinePaymentEnabled || !orderId || !accessToken) return
        const key = String(orderId)
        if (paymentRefetchTimersRef.current[key]) {
            clearTimeout(paymentRefetchTimersRef.current[key])
        }
        paymentRefetchTimersRef.current[key] = setTimeout(() => {
            const order = ordersRef.current.find((o) => String(o._id) === key)
            const fields = orderFieldsRef.current.find((f) => String(f._id) === key)
            const body = getPaymentPreviewRequestBody(order, { shipVia: fields?.shipVia })
            if (!body) return

            previewPaymentSummary(accessToken, body)
                .then((response) => {
                    const summary = response.data?.paymentSummary
                    if (!summary) return
                    setOrders((prev) =>
                        prev.map((o) =>
                            String(o._id) === key
                                ? mergePaymentPreview(o, summary)
                                : o
                        )
                    )
                })
                .catch(() => {})
        }, 300)
    }

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
        setOpenBO(false)
        setCurrOrder(null)
        setInvalidSelectedOrders([])
        setIsSelectedSubmit(false)
        setIsAllSubmit(false)
        setInvoice(null)
        if(isOrdersValid && !currOrder && isSubmitCompleted){
            dispatch(cartCountActions.getProductCount(accessToken, user.id))
            props.history.push('/orders');
        }
    }

    function handleCloseBO() {
        setOpenBO(false);
    }

    function handleCloseCW() {
        setOpenCW(false);
    }

    function handleClickOpenBO() {
        setOpenBO(true);
    }

    const handleAccordionChange = (panel) => (event, newExpanded) => {

        setExpanded(newExpanded ? panel : "")

        // Auto-select ship via if only one option is available when panel is expanded
        if (newExpanded) {
            const panelIndex = panel.replace('panel', '')
            const orderIndex = parseInt(panelIndex)
            autoSelectShipVia(orderIndex)
            const order = orders[orderIndex]
            if (onlinePaymentEnabled && order?._id) {
                fetchPaymentStatus(order._id)
            }
        }

    };

    function runPostPaymentStatusSideEffects(orderId, data) {
        if (!data || !orderId) return
        const oid = String(orderId)
        const { paymentStatus, orderStatus, lastTransaction } = data
        const submissionStatus = lastTransaction?.submissionStatus

        if (paymentStatus !== 'completed') return

        if (submissionStatus === 'failed') {
            if (!paymentAutoSubmitFailedShownRef.current.has(oid)) {
                paymentAutoSubmitFailedShownRef.current.add(oid)
                const orderRow = orders.find((o) => String(o._id) === oid)
                const supplierName =
                    orderRow?.supplier?.[0]?.entityName || 'your supplier'
                const serverText = lastTransaction?.failureReason
                const text =
                    serverText ||
                    'Your payment may have been processed, but this order could not be completed in the marketplace. ' +
                    'Refunds are not handled in this system—please contact ' +
                    supplierName +
                    ' directly to arrange a refund or another resolution. ' +
                    'You can use Reset Payment below only if a payment session is still in progress and your supplier advises it.'
                setPaymentInlineByOrderId((prev) => ({
                    ...prev,
                    [oid]: {
                        variant: 'danger',
                        text
                    }
                }))
                setTimeout(() => {
                    setPaymentInlineByOrderId((prev) => {
                        const next = { ...prev }
                        delete next[oid]
                        return next
                    })
                }, 12000)
            }
            return
        }

        const submittedOk =
            submissionStatus === 'submitted' ||
            (orderStatus != null && orderStatus !== 'Not Submitted')
        if (!submittedOk) {
            if (!paymentCompletedRetryScheduledRef.current.has(oid)) {
                paymentCompletedRetryScheduledRef.current.add(oid)
                setTimeout(() => fetchPaymentStatus(orderId), 2000)
            }
            return
        }

        paymentCompletedRetryScheduledRef.current.delete(oid)

        if (paymentSuccessHandledOrderIdsRef.current.has(oid)) return
        paymentSuccessHandledOrderIdsRef.current.add(oid)

        setIsOrderUpdated((v) => !v)
        setIsOrdersValid(true)
        setIsSubmitCompleted(true)
        setDialogMessage('Your order has been submited.')
        const orderRow = orders.find((o) => String(o._id) === oid)
        const fields = orderFields.find((f) => String(f._id) === oid)
        setPickupInvoiceFromOrder(orderRow, fields)
        handleClickOpen()
    }

    const fetchPaymentStatus = async (orderId) => {
        if (!orderId || paymentLoadingByOrderId[orderId]) return
        setPaymentLoadingByOrderId(prev => ({ ...prev, [orderId]: true }))
        setPaymentErrorByOrderId(prev => ({ ...prev, [orderId]: null }))
        try {
            const res = await getPaymentStatus(orderId, accessToken)
            setPaymentStatusByOrderId(prev => ({ ...prev, [orderId]: res.data }))
            runPostPaymentStatusSideEffects(orderId, res.data)
        } catch (err) {
            setPaymentErrorByOrderId(prev => ({ ...prev, [orderId]: err.response?.data?.error || 'Failed to load payment status' }))
        } finally {
            setPaymentLoadingByOrderId(prev => ({ ...prev, [orderId]: false }))
        }
    }
    fetchPaymentStatusRef.current = fetchPaymentStatus

    const submitPaymentForm = (paymentUrl, formFields) => {
        console.log('[AgilePay] Form submit (Step 6):', {
            paymentUrl,
            method: 'POST',
            formFields: { ...formFields, token: formFields.token ? `${String(formFields.token).slice(0, 12)}...` : formFields.token }
        })
        const form = document.createElement('form')
        form.method = 'POST'
        form.action = paymentUrl
        form.target = '_blank'
        Object.entries(formFields).forEach(([k, v]) => {
            const input = document.createElement('input')
            input.type = 'hidden'
            input.name = k
            input.value = String(v ?? '')
            form.appendChild(input)
        })
        document.body.appendChild(form)
        form.submit()
        document.body.removeChild(form)
    }

    const handleResetPaymentConfirm = async () => {
        if (!resetPaymentOrderId) return
        setResetPaymentLoading(true)
        try {
            await resetPayment(resetPaymentOrderId, accessToken)
            const rid = String(resetPaymentOrderId)
            paymentSuccessHandledOrderIdsRef.current.delete(rid)
            paymentAutoSubmitFailedShownRef.current.delete(rid)
            paymentCompletedRetryScheduledRef.current.delete(rid)
            setPaymentInlineByOrderId((prev) => {
                const next = { ...prev }
                delete next[rid]
                return next
            })
            setPaymentStatusByOrderId(prev => ({ ...prev, [resetPaymentOrderId]: undefined }))
            setPaymentErrorByOrderId(prev => ({ ...prev, [resetPaymentOrderId]: null }))
            fetchPaymentStatus(resetPaymentOrderId)
        } catch (err) {
            const msg = err.response?.data?.error || 'Failed to reset payment'
            setPaymentErrorByOrderId(prev => ({ ...prev, [resetPaymentOrderId]: msg }))
        } finally {
            setResetPaymentLoading(false)
            setResetPaymentOrderId(null)
        }
    }

    // Helper function to get the appropriate price field based on user role
    const getProductPrice = (product) => {
        if(user.roles.includes("buyer_external")) {
            return product.fob || 0;
        }
        return (product.listPrice || product.listPrice == '') ? product.listPrice : product.price;
    }

    // Helper function to check if price is valid
    const isProductPriceValid = (product) => {
        if(user.roles.includes("buyer_external")) {
            return product.fob !== '' && product.fob !== undefined && product.fob !== null;
        }
        if(product.listPrice || product.listPrice == ''){
            return product.listPrice !== '';
        }
        return product.price !== '';
    }

    /**
     * Same rules as handleSubmitSingleOrder (stock, prices, catch weights, dates).
     * @returns {{ valid: boolean, message: string }}
     */
    const validateSingleOrderForSubmit = (order, currOrderFields) => {
        if (!currOrderFields) {
            return { valid: false, message: "Order details are incomplete. Please update the cart." };
        }
        let isOrdersValid = true;
        let isCatchWeightValid = true;
        let invalidMessage = "";
        const outOfStockItem = [];
        const invalidCatchWeightItems = [];

        order.products.forEach((product) => {
            if (product._id !== process.env.REACT_APP_FUEL_ID) {
                const stockQty = getInventoryQty(product, user);
                if (stockQty !== null && product.amount > stockQty) {
                    isOrdersValid = false;
                    outOfStockItem.push(product.name);
                }
            }
            const productPrice = getProductPrice(product);
            if (productPrice === "" || productPrice < 0) {
                isOrdersValid = false;
                invalidMessage += "All unit price must be 0 or greater. ";
            }
            if (currOrderFields.shipVia == "HOME" && product.isCatchWeight) {
                if (product.catchWeights && product.catchWeights.length < product.amount) {
                    isCatchWeightValid = false;
                    invalidCatchWeightItems.push(product.name);
                } else if (!product.catchWeights) {
                    isCatchWeightValid = false;
                    invalidCatchWeightItems.push(product.name);
                }
            }
        });

        const orderProducts = order.products.filter((p) => p.amount > 0);
        if (orderProducts.length === 0) {
            return { valid: false, message: "Add at least one product with quantity greater than zero." };
        }

        if (
            !currOrderFields.invoiceDate ||
            !currOrderFields.shipDate ||
            currOrderFields.invoiceDate === "" ||
            currOrderFields.shipDate === ""
        ) {
            isOrdersValid = false;
            invalidMessage += "To submit, order must have an invoice date and a ship date. ";
        }

        if (outOfStockItem.length > 0) {
            invalidMessage +=
                "Not enough inventory for the following items to fulfill order: " +
                outOfStockItem.join(", ");
        }
        if (!isCatchWeightValid) {
            isOrdersValid = false;
            invalidMessage +=
                "All catch weight items must register weights! Items missing weights: " +
                invalidCatchWeightItems.join(", ");
        }

        return {
            valid: isOrdersValid && isCatchWeightValid,
            message: invalidMessage.trim() || "Validation failed.",
        };
    };

    const handlePayClick = async (order) => {
        const orderId = order._id;
        if (payInProgressByOrderId[orderId]) return;
        if (user.roles && user.roles.includes("buyer_creator")) {
            setPaymentErrorByOrderId((prev) => ({
                ...prev,
                [orderId]: "buyer_creator role cannot submit orders. Please contact an approver.",
            }));
            return;
        }
        const currOrderFields = orderFields.find((curr) => curr._id == order._id);
        const validation = validateSingleOrderForSubmit(order, currOrderFields);
        if (!validation.valid) {
            setPaymentErrorByOrderId((prev) => ({ ...prev, [orderId]: validation.message }));
            return;
        }
        setPayInProgressByOrderId((prev) => ({ ...prev, [orderId]: true }));
        setPaymentErrorByOrderId((prev) => ({ ...prev, [orderId]: null }));
        try {
            const idx = orders.findIndex((o) => o._id === order._id);
            const orderProducts = order.products.filter((p) => p.amount > 0);
            await saveOrders(
                [
                    {
                        orderId: order._id,
                        products: orderProducts,
                        ...orderFields[idx],
                    },
                ],
                accessToken
            );
            const res = await initiatePayment(orderId, accessToken);
            if (res.data?.formFields && res.data?.paymentUrl) {
                submitPaymentForm(res.data.paymentUrl, res.data.formFields);
                setTimeout(() => fetchPaymentStatus(orderId), 2000);
            } else if (res.data?.paymentUrl) {
                window.open(res.data.paymentUrl, "_blank", "noopener,noreferrer");
                setTimeout(() => fetchPaymentStatus(orderId), 2000);
            } else {
                setPaymentErrorByOrderId((prev) => ({
                    ...prev,
                    [orderId]: "No payment URL returned",
                }));
            }
        } catch (err) {
            const msg = err.response?.data?.error || "Payment initiation failed";
            setPaymentErrorByOrderId((prev) => ({ ...prev, [orderId]: msg }));
        } finally {
            setPayInProgressByOrderId((prev) => ({ ...prev, [orderId]: false }));
        }
    };

    const handlePayOnDeliveryClick = async (order) => {
        if (user.roles && user.roles.includes("buyer_creator")) {
            setMessageBO("buyer_creator role cannot submit orders. Please contact an approver.");
            setOpenBO(true);
            return;
        }
        const currOrderFields = orderFields.find((curr) => curr._id == order._id);
        const validation = validateSingleOrderForSubmit(order, currOrderFields);
        if (!validation.valid) {
            setDialogMessage(validation.message);
            handleClickOpen();
            return;
        }
        let orderStatus = "Submitted";
        if (
            user.roles.includes("buyer_store") ||
            user.roles.includes("buyer_external") ||
            user.roles.includes("buyer_store_admin")
        ) {
            orderStatus = "Pending Approval";
        }
        const orderProducts = order.products.filter((p) => p.amount > 0);
        const ordersToSubmit = [
            {
                ...order,
                user: user,
                status: orderStatus,
                products: orderProducts,
                ...currOrderFields,
            },
        ];
        try {
            const response = await submitOrders(user.id, ordersToSubmit, accessToken, "pay_on_delivery");
            setIsSubmitCompleted(true);
            setDialogMessage("Your order has been submitted for pay on delivery.");
            setIsOrdersValid(true);
            setPickupInvoiceAfterSubmit(response, ordersToSubmit);
            handleClickOpen();
            setCurrOrder(null);
        } catch (e) {
            const msg =
                e.response?.data?.error ||
                e.message ||
                'Unable to submit this order. Please try again or contact your supplier.';
            setDialogMessage(msg);
            handleClickOpen();
        }
    };

    const handleSubmitOrder = async (isAdminOverride = false) => {

        // Check if user is buyer_creator - they cannot submit orders
        if(user.roles && user.roles.includes("buyer_creator")){
            setMessageBO("buyer_creator role cannot submit orders. Please contact an approver.");
            setOpenBO(true);
            return;
        }

        if (isAnyOrderPayable) {
            setDialogMessage("Online payment is enabled for your account. Please use Pay & Submit or Pay on Delivery in the cart.");
            handleClickOpen();
            return;
        }

        setIsAllSubmit(true)
        let ordersToSubmit = []
        let ordersToSave = []

        let orderStatus = "Submitted"
        if(user.roles.includes("buyer_store") || user.roles.includes("buyer_external") || user.roles.includes("buyer_store_admin")){
            orderStatus = "Pending Approval"
        }

        let isOrdersValid = true

        orders.map((order, index) => {
            let orderProducts = []

            order.products.map(product => {
                if(!isProductPriceValid(product)){
                    isOrdersValid = false
                }
                if(product._id !== process.env.REACT_APP_FUEL_ID){
                    const stockQty = getInventoryQty(product, user);
                    if(stockQty !== null && product.amount > stockQty){
                        isOrdersValid = false
                    }
                }
                if(product.amount > 0){
                    orderProducts.push(product)
                }
            })

            if(orderProducts.length > 0){
                ordersToSubmit.push({
                    ...order,
                    products : orderProducts,
                    status: orderStatus,
                    ...orderFields[index]
                })
            } else {
                ordersToSave.push({
                    orderId : order._id,
                    products : orderProducts,
                    ...orderFields[index]
                })
            }
        })

        ordersToSubmit.forEach(order => {
            if(order.invoiceDate && order.shipDate && order.invoiceDate !== '' && order.shipDate !== ''){

            } else{
                isOrdersValid = false
                setInvalidSelectedOrders(oldInvalidSelectedOrders => [...oldInvalidSelectedOrders, order])
            }
        })

        setIsOrdersValid(isOrdersValid)

        if(isOrdersValid){
            if(ordersToSubmit.length > 0){
                // console.log("Orders to submit: ", ordersToSubmit)
                await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                    setPickupInvoiceAfterSubmit(response, ordersToSubmit)
                }).catch(e=>{console.log(e)})
            }
            if(ordersToSave.length > 0){
                // console.log("Orders to save: ", ordersToSave)
                await saveOrders(ordersToSave, accessToken).then(response =>{
                }).catch(e=>{console.log(e)})
            }
            setIsSubmitCompleted(true)
            setDialogMessage("Your order has been submited.")
            handleClickOpen()
        } else{
            if(isAdminOverride){
                if(ordersToSubmit.length > 0){
                    // console.log("Orders to submit: ", ordersToSubmit)
                    await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                        setPickupInvoiceAfterSubmit(response, ordersToSubmit)
                    }).catch(e=>{console.log(e)})
                }
                if(ordersToSave.length > 0){
                    // console.log("Orders to save: ", ordersToSave)
                    await saveOrders(ordersToSave, accessToken).then(response =>{
                    }).catch(e=>{console.log(e)})
                }
                setDialogMessage("Your order has been submited.")
                setIsSubmitCompleted(true)
                setIsOrdersValid(true)
                setSelectedOrders([])
                handleClickOpen()
            } else{
                setDialogMessage("To submit, orders must have an invoice date and a ship date. All unit prices must be 0 or greater. " +
                                `Not enough items to fulfill an order, except for fuel, amount to order must be less than available quantity. Review the orders.`)
                handleClickOpen()
            }
        }
    }

    const handleSubmitSelectedOrders = async (isAdminOverride = false) => {

        // Check if user is buyer_creator - they cannot submit orders
        if(user.roles && user.roles.includes("buyer_creator")){
            setMessageBO("buyer_creator role cannot submit orders. Please contact an approver.");
            setOpenBO(true);
            return;
        }

        if (orders.filter(o => selectedOrders.includes(o._id)).some(o => paymentStatusByOrderId[o._id]?.isPayable)) {
            setDialogMessage("Online payment is enabled for your account. Please use Pay & Submit or Pay on Delivery in the cart.");
            handleClickOpen();
            return;
        }

        setIsSelectedSubmit(true)
        let ordersToSubmit = []
        let isOrdersValid = true

        let orderStatus = "Submitted"
        if(user.roles.includes("buyer_store") || user.roles.includes("buyer_external") || user.roles.includes("buyer_store_admin")){
            orderStatus = "Pending Approval"
        }

        const ordersSelectedToSubmit = orders.filter(curr => selectedOrders.includes(curr._id))

        ordersSelectedToSubmit.map((order, index) => {
            let orderProducts = []
            const currOrderFields = orderFields.find(curr => curr._id == order._id)

            order.products.map(product => {
                const productPrice = getProductPrice(product)
                if(productPrice === '' || productPrice < 0){
                    isOrdersValid = false
                }
                if(product._id !== process.env.REACT_APP_FUEL_ID){
                    const stockQty = getInventoryQty(product, user);
                    if(stockQty !== null && product.amount > stockQty){
                        isOrdersValid = false
                    }
                }
                if(product.amount > 0){
                    orderProducts.push(product)
                }
            })

            if(orderProducts.length > 0){
                ordersToSubmit.push({
                    ...order,
                    products : orderProducts,
                    status: orderStatus,
                    ...currOrderFields
                })
            } 
        })

        ordersToSubmit.forEach(order => {
            console.log("Validating orders: ", order)
            if(order.invoiceDate && order.shipDate && order.invoiceDate !== '' && order.shipDate !== ''){

            } else{
                isOrdersValid = false
                setInvalidSelectedOrders(oldInvalidSelectedOrders => [...oldInvalidSelectedOrders, order])
            }
        })

        setIsOrdersValid(isOrdersValid)

        if(isOrdersValid && ordersToSubmit.length > 0){
            
            await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                setPickupInvoiceAfterSubmit(response, ordersToSubmit)
            }).catch(e=>{console.log(e)})
            setIsSubmitCompleted(true)
            setDialogMessage("Your order has been submited.")
            handleClickOpen()
        } else{
            if(isAdminOverride){
                await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                    setPickupInvoiceAfterSubmit(response, ordersToSubmit)
                    setIsSubmitCompleted(true)
                    setDialogMessage("Your order has been submited.")
                    setIsOrdersValid(true)
                    setSelectedOrders([])
                    handleClickOpen()
                    
                }).catch(e=>{console.log(e)})
            } else{
                setDialogMessage("To submit, orders must have an invoice date and a ship date. All unit prices must be 0 or greater. " +
                                `Not enough items to fulfill an order, except for fuel, amount to order must be less than available quantity. Review the orders.`)
                handleClickOpen()
            }
        }
    }

    const handleSubmitSingleBackOrder = (order) => {
        // Check if user is buyer_creator - they cannot submit orders
        if(user.roles && user.roles.includes("buyer_creator")){
            setMessageBO("buyer_creator role cannot submit orders. Please contact an approver.");
            setOpenBO(true);
            return;
        }
        if (paymentStatusByOrderId[order._id]?.isPayable) {
            setDialogMessage("Online payment is enabled for your account. Please use Pay & Submit or Pay on Delivery in the cart.");
            handleClickOpen();
            return;
        }
        setCurrOrder(order)
        setMessageBO("Are you sure you want to submit as Back Order.")
        setCurrOrderStatus("Back Order")
        setOpenBO(true)
    }

    const handleSubmitSingleQuote = (order) => {
        // Check if user is buyer_creator - they cannot submit orders
        if(user.roles && user.roles.includes("buyer_creator")){
            setMessageBO("buyer_creator role cannot submit orders. Please contact an approver.");
            setOpenBO(true);
            return;
        }
        if (paymentStatusByOrderId[order._id]?.isPayable) {
            setDialogMessage("Online payment is enabled for your account. Please use Pay & Submit or Pay on Delivery in the cart.");
            handleClickOpen();
            return;
        }
        setCurrOrder(order)
        setMessageBO("Are you sure you want to submit as Quote.")
        setCurrOrderStatus("Quote")
        setOpenBO(true)
    }

    const handleSubmitSingleOrder = async (order, status, isAdminOverride = false) => {

        // Check if user is buyer_creator - they cannot submit orders
        if(user.roles && user.roles.includes("buyer_creator")){
            setMessageBO("buyer_creator role cannot submit orders. Please contact an approver.");
            setOpenBO(true);
            return;
        }

        if (paymentStatusByOrderId[order._id]?.isPayable) {
            setDialogMessage("Online payment is enabled for your account. Please use Pay & Submit or Pay on Delivery in the cart.");
            handleClickOpen();
            return;
        }

        let isOrdersValid = true
        let isCatchWeightValid = true
        let ordersToSubmit = []

        let currOrderFields = orderFields.find(curr => curr._id == order._id)
        let orderProducts = []

        let invalidMessage = ""
        let outOfStockItem = []
        let invalidCatchWeightItems = []

        let orderStatus = status
        if(user.roles.includes("buyer_store") || user.roles.includes("buyer_external") || user.roles.includes("buyer_store_admin")){
            orderStatus = "Pending Approval"
        }

        order.products.map(product => {
            if(product._id !== process.env.REACT_APP_FUEL_ID){
                const stockQty = getInventoryQty(product, user);
                if(stockQty !== null && product.amount > stockQty){
                    isOrdersValid = false
                    outOfStockItem.push(product.name)
                    setCurrOrder(order)
                }
            }
            const productPrice = getProductPrice(product)
            if(productPrice === '' || productPrice < 0){
                isOrdersValid = false
                invalidMessage += "All unit price must be 0 or greater. "
                setCurrOrder(null)
            }
            
            if(currOrderFields.shipVia == "HOME" && product.isCatchWeight){
                if(product.catchWeights && product.catchWeights.length < product.amount){
                    
                    isCatchWeightValid = false
                    invalidCatchWeightItems.push(product.name)
                } else if(!product.catchWeights){
                    
                    isCatchWeightValid = false
                    invalidCatchWeightItems.push(product.name)
                }
            }

            if(product.amount > 0){
                orderProducts.push(product)
            }
        })

        if(orderProducts.length > 0){
            ordersToSubmit.push({
                ...order,
                user: user,
                status: orderStatus,
                products : orderProducts,
                ...currOrderFields
            })
        } 

        if(ordersToSubmit[0].invoiceDate && ordersToSubmit[0].shipDate && ordersToSubmit[0].invoiceDate !== '' && ordersToSubmit[0].shipDate !== ''){

        } else{
            isOrdersValid = false
            invalidMessage += "To submit, order must have an invoice date and a ship date. "
            setCurrOrder(null)
        }

        if(outOfStockItem.length > 0){
            invalidMessage += "Not enough inventory for the following items to fulfill order: " + outOfStockItem.join(", ")
        }

        if(!isCatchWeightValid){
            isOrdersValid = false

            invalidMessage += "All catch weight items must register weights! Items missing weights: " + invalidCatchWeightItems.join(", ")
            setCurrOrder(null)
        }

        setIsOrdersValid(isOrdersValid)

        if(isOrdersValid){
            await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                console.log("Response: ", response)
                setIsSubmitCompleted(true)
                setDialogMessage("Your order has been submited.")
                setIsOrdersValid(true)
                handleClickOpen()
                setCurrOrder(null)
                setPickupInvoiceAfterSubmit(response, ordersToSubmit)
            }).catch(e=>{console.log(e)})
        } else{
            if(isAdminOverride){
                await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                    console.log("Response: ", response)
                    setIsSubmitCompleted(true)
                    setDialogMessage("Your order has been submited.")
                    setIsOrdersValid(true)
                    handleClickOpen()
                    setCurrOrder(null)
                    setPickupInvoiceAfterSubmit(response, ordersToSubmit)
                }).catch(e=>{console.log(e)})
            } else{
                setDialogMessage(invalidMessage)
                handleClickOpen()
            }
        }
    }

    const handleSaveOrders = () => {
        let ordersToSubmit = []

        orders.map((order, index) => {
            let orderProducts = []

            order.products.map(product => {
                const productPrice = getProductPrice(product)
                if(productPrice === '' || productPrice < 0){
                    isOrdersValid = false
                }
                if(product.amount > 0){
                    orderProducts.push(product)
                }
            })
            
            ordersToSubmit.push({
                orderId : order._id,
                products : orderProducts,
                ...orderFields[index]
            })
        })
        
        console.log(ordersToSubmit)

        saveOrders(ordersToSubmit, accessToken).then(response =>{
            window.location.reload()
        }).catch(e=>{console.log(e)})
    }

    const handlePrintInvoice = async () => {

        const salesTaxCode = invoice.company[0].salesTaxCode
        let municipalTaxSum = 0
        let stateTaxSum = 0

        invoice.products.forEach(currProduct => {
            if(currProduct.isTaxable){
                const productPrice = getProductPrice(currProduct)
                if(salesTaxCode == "SALES PR"){
                    stateTaxSum += (productPrice * currProduct.amount) * 0.105
                    municipalTaxSum += (productPrice * currProduct.amount) * 0.01
                } else if(salesTaxCode == "10.5C"){
                    stateTaxSum += (productPrice * currProduct.amount) * 0.105
                }
            }
        })

        let totalAmount = 0
        const salesOrderProductsData = invoice.products.map(currItem => {
            let itemPrice = getProductPrice(currItem)
            let itemTotalAmount = 0

            if(invoice.shipVia == "HOME" && currItem.isCatchWeight){
                const totalWeight = currItem.catchWeights?.length > 0 ? currItem?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
                itemTotalAmount = (itemPrice * totalWeight)
                totalAmount += itemPrice * totalWeight;
            } else{
                itemTotalAmount = (itemPrice * currItem.amount)
                totalAmount += itemPrice * currItem.amount
            }
            
            return {
                name: currItem.name,
                category: currItem.category,
                sku: currItem.sku,
                unitPrice: itemPrice,
                units: currItem.amount,
                itemPrice: itemPrice,
                totalAmount: itemTotalAmount.toFixed(2),
                isCatchWeight: currItem.isCatchWeight,
                catchWeights: currItem.catchWeights ? currItem.catchWeights : [],
            }
        })
        const salesOrderData = {
            storeName: invoice.companyName,
            submissionDate: invoice.submissionDate,
            requestedDeliveryDate: invoice.shipDate,
            routeName: invoice.routes?.[0]?.name ?? 'Pick Up',
            orderNumber: invoice.orderNumber,
            salesRep: invoice.user[0].fullName,
            products: salesOrderProductsData,
            clientNumber: invoice.company[0].sageCustomerId,
            paymentTerm: invoice.company[0].dueDays,
            supplierName: invoice.supplier[0].entityName,
            supplierDescription: invoice.supplier[0].description,
            supplierPhone1: invoice.supplier[0].phoneNumber,
            supplierPhone2: invoice.supplier[0].phoneNumber2,
            supplierFax: invoice.supplier[0].fax,
            supplierAddress: `${invoice.supplier[0].physicalAddress}, ${formatPrMunicipalityForPdf(invoice.supplier[0].physicalCity)}, Puerto Rico, ${invoice.supplier[0].physicalZipcode}`,
            supplierDisclaimer: invoice.supplier[0].disclaimer,
            totalAmount: totalAmount.toFixed(2),
            sageInvoiceNumber: invoice.sageInvoiceNumber ? invoice.sageInvoiceNumber : false,
            salesTaxAmount: invoice.salesTaxAmount ? invoice.salesTaxAmount : false,
            totalCostTax: (totalAmount + stateTaxSum + municipalTaxSum).toFixed(2),
            comment: invoice.comment,
            stateTax: stateTaxSum,
            municipalTax: municipalTaxSum
        }
        
        const supplierTenantId = invoice.supplier[0].tenantId
        const urlPath = process.env.REACT_APP_WMS_API_HTTPS + (process.env.REACT_APP_ENV === 'DEV' ?
            `${process.env.REACT_APP_WMS_API_URL}/tenants/${supplierTenantId}/route_records/store_order_endpoint_pdf` :
            `${supplierTenantId}.${process.env.REACT_APP_WMS_API_URL}/tenants/${supplierTenantId}/route_records/store_order_endpoint_pdf`
          );

        const response = await axios.post(urlPath, 
        // const response = await axios.post("http://localhost:8003/api/tenants/wahmey/route_records/store_order_endpoint_pdf", 
        salesOrderData, {
            responseType: 'arraybuffer', // Ensure the response type is set to arraybuffer
        });

        // Create a Blob from the PDF data
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open a new tab with the PDF
        const newTab = window.open(pdfUrl, '_blank');

        // handleClose()
    }

    useEffect(() =>{
        fetchorders(user.id,accessToken, null, userFilter).then(response =>{
            // console.log("Orders", response.data)
            let confirmationOrders = response.data.filter(order => order.products.length > 0)

            let orderFields = []
            if(process.env.REACT_APP_BIOWARE_TENANT == 'biowarebuyer'){

                confirmationOrders.forEach((order, orderIndex) => {
                    orderFields.push({
                        _id: order._id,
                        comment: order.comment ? order.comment : '',
                        shipDate: order.shipDate ? order.shipDate : '',
                        invoiceDate: order.invoiceDate ? order.invoiceDate : '',
                        customerPo : order.customerPo ? order.customerPo : '',
                        shipVia : order.shipVia ? order.shipVia : order.company[0].shipVia,
                    })

                    const fuelItem = order.products.find(product => product._id == process.env.REACT_APP_FUEL_ID)
                    if(fuelItem){
                        let products = order.products.filter(product => product._id !== fuelItem._id)

                        products.push(fuelItem)

                        const newOrder = {
                            ...order,
                            products : products
                        }

                        confirmationOrders[orderIndex] = newOrder
                    }

                })
            } if(process.env.REACT_APP_MCS_TENANT == user.tenant){
                confirmationOrders.forEach((order, index) => {
                    orderFields.push({
                        _id: order._id,
                        comment: order.comment ? order.comment : '',
                        shipDate: order.shipDate ? order.shipDate : '',
                        invoiceDate: order.invoiceDate ? order.invoiceDate : '',
                        customerPo : order.customerPo ? order.customerPo : '',
                        expectedDeliveryDate : order.expectedDeliveryDate ? order.expectedDeliveryDate : '',
                        shipVia : order.shipVia ? order.shipVia : order.company[0].shipVia,
                        proofOfDelivery : order.proofOfDelivery ? order.proofOfDelivery : '',
                        phoneNumber : order.phoneNumber ? order.phoneNumber : '',
                        deliveryPurpose : order.deliveryPurpose ? order.deliveryPurpose : '',
                        contactPerson : order.contactPerson ? order.contactPerson : '',

                    })
                })
            } else {
                confirmationOrders.forEach((order, index) => {
                    orderFields.push({
                        _id: order._id,
                        comment: order.comment ? order.comment : '',
                        shipDate: order.shipDate ? order.shipDate : '',
                        invoiceDate: order.invoiceDate ? order.invoiceDate : '',
                        customerPo : order.customerPo ? order.customerPo : '',
                        shipVia : order.shipVia ? order.shipVia : order.company[0].shipVia,
                    })
                })
            }

            // console.log("Confirmation Orders: ", confirmationOrders)
            if(confirmationOrders.length > 0){
                setOrderFields(orderFields)
                setOrders(confirmationOrders)
                setIsOrdersFetched(true)
                setIsCartEmpty(false)
            } else {
                setOrders([])
                setOrderFields([])
                setIsOrdersFetched(false)
                setIsCartEmpty(true)
            }
        })
    },[userFilter])

    useEffect(() =>{
        fetchorders(user.id,accessToken, null, userFilter).then(response =>{
            // console.log("Orders", response.data)
            let confirmationOrders = response.data.filter(order => order.products.length > 0)
            let orderFields = []

            if(process.env.REACT_APP_BIOWARE_TENANT == user.tenant){
                //if(process.env.REACT_APP_BIOWARE_TENANT == 'biowarebuyer'){

                confirmationOrders.forEach((order, index) => {
                    orderFields.push({
                        _id: order._id,
                        comment: order.comment ? order.comment : '',
                        shipDate: order.shipDate ? order.shipDate : '',
                        invoiceDate: order.invoiceDate ? order.invoiceDate : '',
                        customerPo : order.customerPo ? order.customerPo : '',
                        shipVia : order.shipVia ? order.shipVia : order.company[0].shipVia,
                    })

                    const fuelItem = order.products.find(product => product._id == process.env.REACT_APP_FUEL_ID)
                    if(fuelItem){
                        let products = order.products.filter(product => product._id !== fuelItem._id)

                        products.push(fuelItem)

                        const newOrder = {
                            ...order,
                            products : products
                        }

                        confirmationOrders[index] = newOrder
                    }
                })
            } if(process.env.REACT_APP_MCS_TENANT == user.tenant){
                confirmationOrders.forEach((order, index) => {
                    orderFields.push({
                        _id: order._id,
                        comment: order.comment ? order.comment : '',
                        shipDate: order.shipDate ? order.shipDate : '',
                        invoiceDate: order.invoiceDate ? order.invoiceDate : '',
                        customerPo : order.customerPo ? order.customerPo : '',
                        shipVia : order.shipVia ? order.shipVia : order.company[0].shipVia,
                        expectedDeliveryDate: order.expectedDeliveryDate ? order.expectedDeliveryDate : '',
                        proofOfDelivery : order.proofOfDelivery ? order.proofOfDelivery : '',
                        deliveryPurpose : order.deliveryPurpose ? order.deliveryPurpose : '',
                        allecInvWareHouse : order.allecInvWareHouse ? order.allecInvWareHouse : '',
                        contactPerson : order.contactPerson ? order.contactPerson : '',
                        phoneNumber : order.phoneNumber ? order.phoneNumber : '',
                    })
                })
            } else {
                confirmationOrders.forEach((order, index) => {
                    orderFields.push({
                        _id: order._id,
                        comment: order.comment ? order.comment : '',
                        shipDate: order.shipDate ? order.shipDate : '',
                        invoiceDate: order.invoiceDate ? order.invoiceDate : '',
                        customerPo : order.customerPo ? order.customerPo : '',
                        shipVia : order.shipVia ? order.shipVia : order.company[0].shipVia,
                    })
                })
            }

            if(confirmationOrders.length > 0){
                setOrderFields(orderFields)
                setOrders(confirmationOrders)
                setIsOrdersFetched(true)
                setIsCartEmpty(false)
                // Auto-select ship via for all orders after data is loaded
                setTimeout(() => {
                    confirmationOrders.forEach((order, index) => {
                        autoSelectShipVia(index)
                    })
                }, 100)
            } else {
                setOrders([])
                setOrderFields([])
                setIsOrdersFetched(false)
                setIsCartEmpty(true)
            }
        })
    },[isOrderUpdated, userFilter])

    useEffect(() => {
        if (onlinePaymentEnabled && orders.length > 0) {
            orders.forEach((order) => {
                if (order?._id && !paymentStatusByOrderId[order._id]) {
                    fetchPaymentStatus(order._id)
                }
            })
        }
    }, [onlinePaymentEnabled, orders.length])

    const isAnyOrderPayable = orders.some(
        (order) => paymentStatusByOrderId[order._id]?.isPayable === true
    )

    // Helper function to check if an order can be edited (includes special cases)
    const canEditOrder = (order) => {
        // Standard case: Not Submitted orders can always be edited
        if (order.status === "Not Submitted") {
            return true;
        }
        
        // Special case 1: Received orders with future invoice dates
        if (order.status === "Received" && order.invoiceDate) {
            const today = new Date();
            const invoiceDate = new Date(order.invoiceDate);
            if (invoiceDate.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0)) {
                return true;
            }
        }
        
        // Special case 2: WAHMEY tenant with specific route statuses
        if (user.tenant === process.env.REACT_APP_WAHMEY_TENANT) {
            if (order.routeStatus && 
                order.routeStatus !== 'Completed' && 
                order.routeStatus !== 'Routing' && 
                order.routeStatus !== 'Sent to WMS') {
                return true;
            }
        }
        
        return false;
    };

    const handleProductAmountChange = (orderId, productId, productAmount) => {
        let orderIndex = orders.findIndex(order => order._id === orderId)
        let order = orders.find(order => order._id === orderId)
        let newOrders = orders

        let products = [...order.products]
        let productIndex = products.findIndex(product => product._id === productId)

        const oldTotalAmount = order.totalProductQty
        const oldTotalCost = order.totalCost
        let newTotalAmount = oldTotalAmount
        let newTotalCost = parseFloat(oldTotalCost)

        const product = {...products[productIndex]}
        let productPrice = getProductPrice(product)
        const selectedUnitObject = product.selectedUnit ? product.selectedUnit : product.defaultUnitOfMeasurement
        const conversionFactor = selectedUnitObject ? selectedUnitObject.conversionFactor : 1
        const amountDifference = Math.abs(productAmount - product.amount)

        if(productPrice > 0){
            if(product.amount < productAmount){
                // Amount increasing
                if(product.isStaticCatchWeight && product.catchWeights){
                    newTotalCost += parseFloat(productPrice) * product.staticCatchWeight * amountDifference
                } else{
                    newTotalCost += parseFloat(productPrice) * conversionFactor * amountDifference
                }
                
            } else {
                // Amount decreasing
                if(product.isStaticCatchWeight && product.catchWeights){
                    newTotalCost -= parseFloat(productPrice) * product.staticCatchWeight * amountDifference
                } else{
                    newTotalCost -= parseFloat(productPrice) * conversionFactor * amountDifference
                }
            }
        }
        if(product.amount < productAmount){
            newTotalAmount += amountDifference
            if(product.isStaticCatchWeight && product.catchWeights){
                for(let i = 0; i < amountDifference; i++){
                    product.catchWeights.push(product.staticCatchWeight)
                }
            }
        } else {
            newTotalAmount -= amountDifference
            if(product.isStaticCatchWeight && product.catchWeights){
                for(let i = 0; i < amountDifference; i++){
                    product.catchWeights.pop()
                }
            }
        }

        products[productIndex] = {
            ...product,
            amount : productAmount,
        }

        const newOrder = {
            ...order,
            totalProductQty : newTotalAmount,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }

        newOrders[orderIndex] = newOrder
        
        setOrders([...newOrders])
        scheduleOrderPaymentRefetch(orderId)
    }

    // Helper function to set the appropriate price field based on user role
    const setProductPrice = (product, newPrice) => {
        if(user.roles.includes("buyer_external")) {
            return {
                ...product,
                fob: newPrice
            };
        }
        if(product.listPrice || product.listPrice == ''){
            return {
                ...product,
                listPrice: newPrice
            };
        }
        return {
            ...product,
            price: newPrice
        };
    }

    const handlePriceChange = (orderId, productId, newPrice) => {
        let orderIndex = orders.findIndex(order => order._id === orderId)
        let order = orders.find(order => order._id === orderId)
        let newOrders = orders

        let products = order.products
        let productIndex = products.findIndex(product => product._id === productId)
        const product = products[productIndex]
        const selectedUnitObject = product.selectedUnit ? product.selectedUnit : product.defaultUnitOfMeasurement
        const conversionFactor = selectedUnitObject.conversionFactor

        let newPriceParsed = parseFloat(newPrice)

        const oldPrice = getProductPrice(product)
        const oldTotalCost = order.totalCost
        
        let newTotalCost = parseFloat(oldTotalCost)
        let totalWeight = 0

        if(product.isCatchWeight && product.catchWeights){
            totalWeight = product.catchWeights.length > 0 ? product?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
        }
        
        if(oldPrice == '' || oldPrice == 0){
            newTotalCost -= parseFloat(product.amount * 0)
        } else{
            if(product.isCatchWeight && product.catchWeights){
                newTotalCost -= parseFloat(totalWeight * oldPrice)
            } else{
                newTotalCost -= parseFloat(product.amount * conversionFactor * oldPrice)
            }
        }   

        if(!isNaN(newPriceParsed)){
            if(product.isCatchWeight && product.catchWeights){
                newTotalCost += parseFloat(totalWeight * newPriceParsed)
            } else{
                newTotalCost += parseFloat(product.amount * conversionFactor * newPriceParsed)
            }
        }  

        if(isNaN(newPriceParsed)){
            newPriceParsed = ""
        }

        products[productIndex] = setProductPrice(product, newPriceParsed)

        const newOrder = {
            ...order,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }

        newOrders[orderIndex] = newOrder
        
        setOrders([...newOrders])
        scheduleOrderPaymentRefetch(orderId)
    }

    const handleProductUnitChange = (orderId, productId, selectedUnitId) => {
        let orderIndex = orders.findIndex(order => order._id === orderId)
        let order = orders.find(order => order._id === orderId)
        let newOrders = orders

        let products = order.products
        let productIndex = products.findIndex(product => product._id === productId)
        const product = products[productIndex]

        const itemPrice = getProductPrice(product)
        const oldSelectedUnitObject = product.selectedUnit ? product.selectedUnit : product.defaultUnitOfMeasurement
        const newSelectedUnitObject = product.unitsOfMeasurement.find(uom => uom.uomId == selectedUnitId)
        const oldConversionFactor = oldSelectedUnitObject.conversionFactor
        const newConversionFactor = newSelectedUnitObject.conversionFactor

        const oldTotalCost = order.totalCost
        
        let newTotalCost = parseFloat(oldTotalCost)
        
        if(itemPrice == '' || itemPrice == 0){
            newTotalCost -= parseFloat(product.amount * 0)
        } else{
            newTotalCost -= parseFloat(product.amount * oldConversionFactor * itemPrice)
            newTotalCost += parseFloat(product.amount * newConversionFactor * itemPrice)
        }   

        products[productIndex] = {
            ...products[productIndex],
            selectedUnit : newSelectedUnitObject,
        }

        const newOrder = {
            ...order,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }

        newOrders[orderIndex] = newOrder
        
        setOrders([...newOrders])
        scheduleOrderPaymentRefetch(orderId)
    }

    function handleRemove(orderId, productId) {
        let orderIndex = orders.findIndex(order => order._id === orderId)
        let order = orders.find(order => order._id === orderId)
        let newOrders = orders

        const productToRemove = order.products.find(product => product._id == productId)
        const productAmount = productToRemove.amount
        let productPrice = getProductPrice(productToRemove)

        if(productPrice == '' || productPrice == 0){
            productPrice = 0
        }

        // if(productToRemove.isCatchWeight){
        //     productPrice = productPrice * productToRemove.avgWeight
        //     productPrice = Math.round( parseFloat(productPrice) * 1e2 ) / 1e2
        // }

        let newTotalCost = parseFloat(order.totalCost)

        if(productToRemove.isCatchWeight && productToRemove.catchWeights){
            let totalWeight = productToRemove.catchWeights.length > 0 ? productToRemove?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
            newTotalCost -= totalWeight * productPrice
        } else{
            newTotalCost -= productAmount * productPrice
        }

        

        let newTotalAmount = order.totalProductQty
        newTotalAmount -= productAmount

        let products = order.products.filter(product => product._id !== productId)

        const newOrder = {
            ...order,
            totalProductQty : newTotalAmount,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }
        
        if(products.length > 0){
            newOrders[orderIndex] = newOrder
        } else{
            newOrders = orders.filter(currOrder => currOrder._id !== orderId)
        }
        
        setOrders([...newOrders])
        if (products.length > 0) {
            scheduleOrderPaymentRefetch(orderId)
        }
    }

    function handleCatchWeightClick(orderId, productId) {
        const currOrderIndex = orders.findIndex(order => order._id === orderId)
        let currOrder = {...orders[currOrderIndex]}
        let newOrders = [...orders]

        const currProductIndex = currOrder.products.findIndex(product => product._id == productId)
        let currProduct = {...currOrder.products[currProductIndex]}

        let catchWeights = []
        if(typeof currProduct.catchWeights == "undefined"){
            currProduct.catchWeights = catchWeights
        }

        // let totalWeight = 0
        // if(catchWeights.length > 0){
        //     totalWeight = catchWeights.reduce((total, currWeight) => total + parseFloat(currWeight))
        // }

        // let currProductPrice = (currProduct.listPrice || currProduct.listPrice == '') ? currProduct.listPrice : currProduct.price
        // if(currProductPrice == ''){
        //     currProductPrice = 0
        // }
        // const oldTotalCost = currOrder.totalCost
        // let newTotalCost = oldTotalCost + (currProductPrice * totalWeight)
        
        newOrders[currOrderIndex].products[currProductIndex] = currProduct
        // newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))

        setOrders(newOrders)
        setCatchWeightProduct({...currProduct})
        setCatchWeightOrder({...currOrder})

        setOpenCW(true);
    }

    function handleAddCatchWeight() {
        
        if(catchWeightProduct.catchWeights && catchWeightProduct.catchWeights.length >= catchWeightProduct.amount){
            // console.log("Don't do Shit!")
        } else if(typeof catchWeight === "number" && catchWeight > 0){
            const currOrderIndex = orders.findIndex(order => order._id === catchWeightOrder._id)
            let currOrder = {...orders[currOrderIndex]}
            let newOrders = [...orders]

            const currProductIndex = currOrder.products.findIndex(product => product._id == catchWeightProduct._id)
            let currProduct = {...currOrder.products[currProductIndex]}
            
            if(currProduct.catchWeights){
                currProduct.catchWeights.push(catchWeight)
            } else{
                currProduct.catchWeights = [catchWeight]
            }

            let currProductPrice = getProductPrice(currProduct)
            if(currProductPrice == '' || currProductPrice == 0){
                currProductPrice = 0
            }
            const oldTotalCost = currOrder.totalCost
            let newTotalCost = oldTotalCost + (currProductPrice * catchWeight)

            newOrders[currOrderIndex].products[currProductIndex] = currProduct
            newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))

            setOrders(newOrders)
            scheduleOrderPaymentRefetch(catchWeightOrder._id)
            setCatchWeightOrder(currOrder)
            setCatchWeightProduct(currProduct)
            setCatchWeight("")
        }
    }

    function handleRemoveCatchWeight(cw) {
        
        if(catchWeightProduct.catchWeights && catchWeightProduct.catchWeights.length > 0){
            
            const currOrderIndex = orders.findIndex(order => order._id === catchWeightOrder._id)
            let currOrder = {...orders[currOrderIndex]}
            let newOrders = [...orders]

            const currProductIndex = currOrder.products.findIndex(product => product._id == catchWeightProduct._id)
            let currProduct = {...currOrder.products[currProductIndex]}
            
            
            const currrCatchWeightIndex = currProduct.catchWeights.findIndex(catchWeight => catchWeight == cw)
            let catchWeightRemoved = 0
            if (currrCatchWeightIndex > -1) {
                catchWeightRemoved = currProduct.catchWeights[currrCatchWeightIndex]
                currProduct.catchWeights.splice(currrCatchWeightIndex, 1)
            }

            let currProductPrice = getProductPrice(currProduct)
            if(currProductPrice == '' || currProductPrice == 0){
                currProductPrice = 0
            }
            const oldTotalCost = currOrder.totalCost
            let newTotalCost = oldTotalCost - (currProductPrice * catchWeightRemoved)

            newOrders[currOrderIndex].products[currProductIndex] = currProduct
            newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))

            setOrders(newOrders)
            scheduleOrderPaymentRefetch(catchWeightOrder._id)
            setCatchWeightOrder(currOrder)
            setCatchWeightProduct(currProduct)
        }
    }

    // Helper function to check if a product has multiple units of measurement
    const hasMultipleUnits = (product) => {
        return product.unitsOfMeasurement && product.unitsOfMeasurement.length > 1;
    }

    // Helper function to check if any product in an order has multiple units
    const orderHasMultipleUnits = (order) => {
        return order.products.some(product => hasMultipleUnits(product));
    }

    const handleToken = (totalAmount, token) => {
        try {
            axios.post(process.env.REACT_APP_API_URL + "/stripe/pay", {
                token: token.id,
                amount: totalAmount
            }).then((result) => {
                // Run code after successful payment
                handleSubmitOrder()
            })
        } catch (error) {
            console.log(error)
        }
    }

    const tokenHandler = (token) => {
        handleToken(10, token)


    }

    const handleCommentChange = (e, index) => {
        
        let newOrderFields = [...orderFields]
        newOrderFields[index].comment = e.target.value

        setOrderFields(newOrderFields)
    }

    const handleCustomerPoChange = (e, index) => {
        
        let newOrderFields = [...orderFields]
        newOrderFields[index].customerPo = e.target.value

        setOrderFields(newOrderFields)
    }

    const handleOrderExpectedDeliveryDateChange = (e, index) => {
        let newOrderFields = [...orderFields]
        newOrderFields[index].expectedDeliveryDate = e.target.value

        setOrderFields(newOrderFields)
    }

    const handleOrderShipToChange = (index, e) => {
        let newOrderFields = [...orderFields]
        newOrderFields[index].allecInvWareHouse = e.target.value

        setOrderFields(newOrderFields)
    }

    const handleDeliveryPurposeChange = (index, e) => {
        let newOrderFields = [...orderFields]
        newOrderFields[index].deliveryPurpose = e.target.value

        setOrderFields(newOrderFields)
    };

    const handleContactPerson = (index, e) => {
        let newOrderFields = [...orderFields]
        newOrderFields[index].contactPerson = e.target.value

        setOrderFields(newOrderFields)
    };

    const handlePhoneNumber = (index, e) => {
        let newOrderFields = [...orderFields]
        newOrderFields[index].phoneNumber = e.target.value

        setOrderFields(newOrderFields)
    };

    const handleProofOfDeliveryChange = (index, e) => {
        let newOrderFields = [...orderFields]
        newOrderFields[index].proofOfDelivery = e.target.checked

        setOrderFields(newOrderFields)
    };

    const handleDefaultDateChange = (e) => {
        
        let newOrderFields = [...orderFields]

        for(let i = 0; i < newOrderFields.length; i++){
            newOrderFields[i].invoiceDate = e.target.value
            newOrderFields[i].shipDate = e.target.value
        }

        setOrderFields(newOrderFields)
    }

    const handleInvoiceDateChange = (e, index) => {
        
        let newOrderFields = [...orderFields]
        newOrderFields[index].invoiceDate = e.target.value

        if(user.tenant == process.env.REACT_APP_WAHMEY_TENANT){
            newOrderFields[index].shipDate = e.target.value
        }

        setOrderFields(newOrderFields)
    }

    const handleShipDateChange = (e, index) => {
        
        let newOrderFields = [...orderFields]
        newOrderFields[index].shipDate = e.target.value

        if(user.tenant == process.env.REACT_APP_WAHMEY_TENANT){
            newOrderFields[index].invoiceDate = e.target.value
        }

        setOrderFields(newOrderFields)
    }

    const handleShipViaChange = (e, index, orderId) => {
        console.log("Changing ship via to: ", e.target.value)
        let newOrderFields = [...orderFields]
        newOrderFields[index].shipVia = e.target.value

        if(e.target.value == "HOME"){
            const currOrderIndex = orders.findIndex(order => order._id === orderId)
            let currOrder = {...orders[currOrderIndex]}
            let newOrders = [...orders]
            let newTotalCost = currOrder.totalCost

            console.log("NTC: ", newTotalCost)
            
            let resultProducts = currOrder.products.map(item => {

                let currProduct = {...item}
                
                if(currProduct.isStaticCatchWeight && !Array.isArray(currProduct?.catchWeights)){
                    let currProductPrice = getProductPrice(currProduct)
                    let catchWeights = []

                    for(let i = 0; i < currProduct.amount; i++){
                        catchWeights.push(currProduct.staticCatchWeight)
                    }
    
                    const totalWeight = (catchWeights.reduce((total, currWeight) => total + parseFloat(currWeight)))
                    currProduct.catchWeights = catchWeights
                    newTotalCost += totalWeight * currProductPrice
                } 

                return currProduct
            })

            newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))
            newOrders[currOrderIndex].products = resultProducts

            setOrders(newOrders)
            scheduleOrderPaymentRefetch(orderId)
        }

        setOrderFields(newOrderFields)
    }

    // Helper function to get available ship via options for an order
    const getAvailableShipViaOptions = (order) => {
        // Check if order has the required properties
        if (!order || !order.company || !order.company[0] || !order.supplier || !order.supplier[0]) {
            console.log('getAvailableShipViaOptions: Missing required order properties', order)
            return []
        }
        
        const companyShipVia = order.company[0]?.shipVia
        const supplierOptions = order.supplier[0]?.shipViaOptions || []
        const filteredSupplierOptions = supplierOptions.filter(option => option !== companyShipVia)
        const options = [companyShipVia, ...filteredSupplierOptions]
        const finalOptions = options.filter(option => option) // Remove any undefined/null values
        
        return finalOptions
    }

    // Helper function to auto-select ship via when only one option is available
    const autoSelectShipVia = (orderIndex) => {
        const order = orders[orderIndex]
        const orderField = orderFields[orderIndex]
        
        // Check if order and orderField exist
        if (!order || !orderField) {
            console.log(`autoSelectShipVia: Missing order or orderField for index ${orderIndex}`)
            return
        }
        
        const availableOptions = getAvailableShipViaOptions(order)
        
        if (availableOptions.length === 1 && (!orderField.shipVia || orderField.shipVia === '')) {
            handleShipViaChange({ target: { value: availableOptions[0] } }, orderIndex, order._id)
        }
    }

    const handleOrderClick = (order) => {
        console.log("Order clicked: ", order)
        
        setClickedOrder(order)
        setIsOderSummaryClicked(true)
    }
    
    const handleOrderSelect = (order) => {
        
        const orderFound = selectedOrders.find(currOrderId => currOrderId == order._id)
        if(orderFound){
            const newSelectedOrders = selectedOrders.filter(currOrderId => currOrderId != order._id)
            setSelectedOrders(newSelectedOrders)
        } else{
            setSelectedOrders(oldSelectedOrders => [...oldSelectedOrders, order._id])
        }
    }

    useEffect(() => {
        if(user.roles && user.roles.includes("buyer_approver")) {
            fetchTenantUsers(accessToken).then(response => {
                setTenantUsers(response.data)
            }).catch(error => console.log(error))
        }
    })

    useEffect(() => {
        if (!accessToken) return
        fetchTenantPaymentSettings(accessToken)
            .then((res) => setOnlinePaymentEnabled(!!res.data?.onlinePaymentEnabled))
            .catch(() => setOnlinePaymentEnabled(false))
    }, [accessToken])

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        if (params.get('payment') === 'cancelled') {
            paymentCancelledQueryRef.current = true
            history.replace({ pathname: '/orders/confirmation' })
        }
    }, [location.search, history])

    useEffect(() => {
        if (!paymentCancelledQueryRef.current) return
        if (!orders.length) {
            paymentCancelledQueryRef.current = false
            return
        }
        const allLoaded = orders.every(
            (o) => o._id && (paymentStatusByOrderId[o._id] !== undefined || paymentErrorByOrderId[o._id])
        )
        if (!allLoaded) return
        setPaymentInlineByOrderId((prev) => {
            const next = { ...prev }
            orders.forEach((order) => {
                const id = String(order._id)
                if (paymentStatusByOrderId[order._id]?.paymentStatus === 'initiated') {
                    next[id] = { variant: 'warning', text: 'Payment was cancelled.' }
                }
            })
            return next
        })
        paymentCancelledQueryRef.current = false
        const timer = setTimeout(() => {
            setPaymentInlineByOrderId((prev) => {
                const next = { ...prev }
                orders.forEach((order) => {
                    const id = String(order._id)
                    if (next[id]?.text === 'Payment was cancelled.') {
                        delete next[id]
                    }
                })
                return next
            })
        }, 5000)
        return () => clearTimeout(timer)
    }, [orders, paymentStatusByOrderId, paymentErrorByOrderId])

    useEffect(() => {
        const refreshPaymentStatusForPending = () => {
            const currentOrders = ordersRef.current
            const currentStatus = paymentStatusByOrderIdRef.current
            const fetchFn = fetchPaymentStatusRef.current
            currentOrders.forEach((order) => {
                if (order?._id && currentStatus[order._id]?.paymentStatus === 'initiated') {
                    fetchFn(order._id)
                }
            })
        }
        const onVisibility = () => {
            if (document.visibilityState === 'visible') {
                refreshPaymentStatusForPending()
            }
        }
        window.addEventListener('focus', refreshPaymentStatusForPending)
        document.addEventListener('visibilitychange', onVisibility)
        return () => {
            window.removeEventListener('focus', refreshPaymentStatusForPending)
            document.removeEventListener('visibilitychange', onVisibility)
        }
    }, [])

    const handleUserFilter = (element) => {
        const clickedTenantUser = tenantUsers.find(tenantUser => tenantUser._id == element.target.value)
        
        if(clickedTenantUser) {
            setUserFilter(clickedTenantUser._id)
        } else {
            setUserFilter(null) // Clear filter to show all orders
        }
        // The useEffect will automatically refetch orders when userFilter changes
    }

    return (
        <>
            {user.roles && user.roles.includes("buyer_approver") && (
                <div className="row justify-content-between mb-5 px-8">
                    <div className="d-flex flex-wrap col-3">
                        <FormControl variant="filled" style={{ width: "100%" }}>
                            <InputLabel>User Filter</InputLabel>
                            <Select
                                MenuProps={{ autoFocus: false }}
                                value={userFilter ? userFilter : ""}
                                style={{ minWidth: "200px" }}
                                input={
                                    <FilledInput
                                        name="userFilter"
                                        id="userFilter"
                                        onChange={(element) => {
                                            handleUserFilter(element);
                                        }}
                                        type="text"
                                        className="form-control form-control-solid h-auto mb-5"
                                    />
                                }
                            >
                                <MenuItem key={0} value={""}>All</MenuItem>
                                {tenantUsers.map((tenantUser,index) =>(
                                    <MenuItem key={tenantUser._id} value={tenantUser._id}>{tenantUser.fullName}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            )}
         
             {(isOrdersFetched && orders.length > 0) ? (
                 isOrderSummaryClicked ? (
                 <OrderSummary currOrder={clickedOrder} setIsOderSummaryClicked={setIsOderSummaryClicked}
                     setIsOrderUpdated={setIsOrderUpdated} isOrderUpdated={isOrderUpdated} />
                 ) : (
                 <div>
                    {orders.map((order, index)=> {
                        const currentOrderField = orderFields[index] || {};
                        const isPaymentStatusLoading = paymentLoadingByOrderId[order._id]
                        const orderPaymentStatus = paymentStatusByOrderId[order._id]
                        const orderPaymentStatusError = paymentErrorByOrderId[order._id]
                        const isPaymentControlsReady =
                            !onlinePaymentEnabled ||
                            (!isPaymentStatusLoading &&
                            (orderPaymentStatus !== undefined || orderPaymentStatusError))
                        const orderInlinePaymentMessage = paymentInlineByOrderId[String(order._id)]
                        const isPayAndSubmitDisabled =
                            isPaymentStatusLoading ||
                            payInProgressByOrderId[order._id] ||
                            orderPaymentStatus?.isPayable === false
                        const mustUsePaymentFlow = onlinePaymentEnabled && orderPaymentStatus?.isPayable
                        const isStandardSubmitDisabled =
                            isPaymentStatusLoading ||
                            orderPaymentStatus?.paymentStatus === 'completed' ||
                            orderPaymentStatus?.paymentStatus === 'initiated' ||
                            mustUsePaymentFlow
                        return (
                        <ExpansionPanel square expanded={expanded === 'panel' + index} onChange={handleAccordionChange('panel' + index)}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls={'panel-content-' + index}
                                id={'panel-header-' + index}
                                >
                                <label className="checkbox checkbox-lg checkbox-single flex-shrink-0 m-0 mx-4">
                                    <input type="checkbox" checked={selectedOrders.find(currOrder => currOrder == order._id)} name="" onClick={() => handleOrderSelect(order)} />
                                    <span></span>
                                </label>
                                <Typography className={classes.heading}>
                                    {`Order #${order?.orderNumber}`}
                                </Typography>
                                <Typography className={classes.secondaryHeading}>{order?.companyName}</Typography>
                                
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <div className="flex-row-fluid ml-lg-8">
                                    <div className="">
                                        <div className="card-body p-0">
                                            <div className="row justify-content-center py-8 px-8 py-md-27 px-md-0">
                                                <div className="col-md-10">
                                                    <div className="col-sm bg-light-primary px-6 py-4 rounded-xl mr-7">
                                                        <div className="table-responsive">
                                                            <table className="table table-borderless">
                                                                <thead>
                                                                    <tr>
                                                                        {
                                                                            user.isSeller ?
                                                                                <th className="pl-4 font-weight-boldest text-uppercase">Customer:</th>
                                                                            :
                                                                                <th className="pl-4 font-weight-boldest text-uppercase">Company:</th>
                                                                        }
                                                                        <th className="font-weight-boldest text-uppercase">Ship To:</th>
                                                                        {
                                                                            user.isSeller ?
                                                                                <th className="font-weight-boldest text-uppercase">Sales Rep:</th>
                                                                                :
                                                                                <th className="font-weight-boldest text-uppercase">Ordering To:</th>
                                                                        }
                                                                        {user.roles && user.roles.includes("buyer_approver") && (
                                                                            <th className="font-weight-boldest text-uppercase">Created by:</th>
                                                                        )}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="font-weight-boldest">
                                                                        <td className="pl-4 d-flex">
                                                                            {/* <h6 className="font-weight-bolder mb-3">Delivery Address:</h6> */}
                                                                            <div className="text-dark-50">
                                                                                <div>{order.company[0].businessName}</div>
                                                                                {/*<div>Melbourne 3000, VIC, Australia</div>*/}
                                                                            </div>
                                                                        </td>
                                                                        <td >
                                                                            {/* <h6 className="font-weight-bolder mb-3">Delivery Address:</h6> */}
                                                                            <div className="text-dark-50">
                                                                                <div>{order.location[0].locationName}</div>
                                                                                <div>{order.location[0].locationAddress1} {order.location[0].locationAddress2}</div>
                                                                                <div>{order.location[0].locationCity}, {order.location[0].locationZipcode}</div>
                                                                                {/*<div>Melbourne 3000, VIC, Australia</div>*/}
                                                                            </div>
                                                                        </td>
                                                                        {
                                                                            user.isSeller ?
                                                                                <td className="text-dark-50">{order.user[0].fullName}</td>
                                                                                :
                                                                                <td className="text-dark-50">{order.supplier[0].entityName}</td>
                                                                        }
                                                                        {user.roles && user.roles.includes("buyer_approver") && (
                                                                            <td className="text-dark-50">
                                                                                {order.user && order.user[0] && order.user[0].email ? order.user[0].email : 'N/A'}
                                                                            </td>
                                                                        )}
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex flex-wrap align-items-center my-3">
                                                        <button type="button" className="btn btn-primary mr-2" onClick={() => handleOrderClick(order)}>Edit Order</button>
                                                    </div>
                                                    <div>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                {process.env.REACT_APP_MCS_TENANT === user.tenant ? (
                                                                    <div className="form-group fv-plugins-icon-container">
                                                                        <label htmlFor={"orderComent"}>Special Instructions</label>
                                                                        <textarea
                                                                            value={currentOrderField.comment || ""}
                                                                            onChange={(e) => handleCommentChange(e, index)}
                                                                            className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                            placeholder={"Special Instructions"}
                                                                            rows="3"
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"orderComent"}>Comment</label>
                                                                    <textarea
                                                                        value={currentOrderField.comment || ""}
                                                                        onChange={(e) => handleCommentChange(e, index)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Comment"}
                                                                        rows="3"
                                                                    />
                                                                </div>
                                                                )}
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"customerPo"}>Customer PO</label>
                                                                    <input
                                                                        value={currentOrderField.customerPo || ""}
                                                                        onChange={(e) => handleCustomerPoChange(e, index)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Customer PO"}
                                                                        type="text"
                                                                    />
                                                                </div>

                                                                {process.env.REACT_APP_MCS_TENANT === user.tenant ? (
                                                                    <div>
                                                                        <div className="form-group fv-plugins-icon-container">
                                                                            <label htmlFor={"deliveryPurpose"}>Delivery
                                                                                Purpose</label>
                                                                            <input
                                                                                value={currentOrderField.deliveryPurpose || ""}
                                                                                onChange={(e) => handleDeliveryPurposeChange(index, e)}
                                                                                className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                                placeholder={"Delivery Purpose"}
                                                                                type="text"
                                                                            />
                                                                        </div>
                                                                        <div className="form-group fv-plugins-icon-container">
                                                                            <label htmlFor={"contactPerson"}>Contact Person</label>
                                                                            <input
                                                                                value={currentOrderField.contactPerson || ""}
                                                                                onChange={(e) => handleContactPerson(index, e)}
                                                                                className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                                placeholder={"Contact Person"}
                                                                                type="text"
                                                                            />
                                                                        </div>
                                                                        <div className="form-group fv-plugins-icon-container">
                                                                            <label htmlFor={"phoneNumber"}>Phone Number</label>
                                                                            <input
                                                                                value={currentOrderField.phoneNumber || ""}
                                                                                onChange={(e) => handlePhoneNumber(index, e)}
                                                                                className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                                placeholder={"Phone Number"}
                                                                                type="text"
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                ) : (
                                                                <FormControl variant="filled" style={{ width: "100%" }}>
                                                                    <InputLabel>Ship Via</InputLabel>
                                                                    <Select
                                                                        MenuProps={{ autoFocus: false }}
                                                                        value={currentOrderField.shipVia || ''}
                                                                        style={{ minWidth: "200px" }}
                                                                        input={<FilledInput name="shipVia" id="shipVia"
                                                                            onChange={(element) => {
                                                                                handleShipViaChange(element, index, order._id);
                                                                                // setCompany(companies.find(company => company._id == element.target.value))
                                                                                // setLocations(companies.find(company => company._id == element.target.value).locations)
                                                                            } }
                                                                            type="text"
                                                                            className="form-control form-control-solid h-auto" />}>

                                                                        <MenuItem key={order.company[0].shipVia} value={order.company[0].shipVia}>{order.company[0].shipVia == "Our Truck" ? "Delivery" : order.company[0].shipVia == "HOME" ? "Pick Up" : order.company[0].shipVia}</MenuItem>
                                                                        {
                                                                            order.supplier[0].shipViaOptions.map((option,index) =>(
                                                                                order.company[0]?.shipVia == option ?
                                                                                null
                                                                                :
                                                                                <MenuItem key={option} value={option}>{option == "Our Truck" ? "Delivery" : option == "HOME" ? "Pick Up" : option}</MenuItem>
                                                                            ))
                                                                        }
                                                                    </Select>
                                                                </FormControl>
                                                                )}
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"invoiceDate"}>Invoice Date</label>
                                                                    <Input
                                                                        type="date"
                                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                        name="personalBirthDate"
                                                                        value={currentOrderField.invoiceDate || ""}
                                                                        onChange={(e) => handleInvoiceDateChange(e, index)}
                                                                    />
                                                                </div>
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"shipDate"}>Ship Date</label>
                                                                    <Input
                                                                        type="date"
                                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                        name="personalBirthDate"
                                                                        value={currentOrderField.shipDate || ""}
                                                                        onChange={(e) => handleShipDateChange(e, index)}
                                                                    />
                                                                </div>

                                                                {process.env.REACT_APP_MCS_TENANT === user.tenant ? (
                                                                    <>
                                                                        <div className="form-group fv-plugins-icon-container">
                                                                            <label htmlFor={"expectedDeliveryDate"}>Expected
                                                                                Delivery Date</label>
                                                                            <Input
                                                                                type="date"
                                                                                className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                                name="expectedDeliveryDate"
                                                                                value={currentOrderField.expectedDeliveryDate || ""}
                                                                                onChange={(e) => handleOrderExpectedDeliveryDateChange(e, index)}
                                                                            />
                                                                        </div>

                                                                        <FormControl variant="filled" style={{width: "100%"}}>
                                                                            <InputLabel>Ship To</InputLabel>
                                                                            <Select
                                                                                MenuProps={{autoFocus: false}}
                                                                                value={order.allecInvWareHouse}
                                                                                style={{minWidth: "200px"}}
                                                                                onChange={(e) => {
                                                                                    handleOrderShipToChange(index, e);
                                                                                }}
                                                                                input={
                                                                                    <FilledInput
                                                                                        name="allecInvWareHouse"
                                                                                        id="allecInvWareHouse"
                                                                                        type="text"
                                                                                        className="form-control form-control-solid h-auto"
                                                                                    />
                                                                                }
                                                                            >
                                                                                {
                                                                                    order.supplier[0].warehouses?.map((warehouse) => (
                                                                                        <MenuItem
                                                                                            key={warehouse.id}
                                                                                            value={warehouse.id}
                                                                                        >
                                                                                            {warehouse.name}
                                                                                        </MenuItem>
                                                                                    ))
                                                                                }
                                                                            </Select>
                                                                        </FormControl>

                                                                        <div>
                                                                            <label htmlFor={"proofOfDeliveryToggle"}>Proof of
                                                                                Delivery</label>
                                                                            <Switch
                                                                                checked={!!currentOrderField.proofOfDelivery}
                                                                                onChange={(e) => handleProofOfDeliveryChange(index, e)}
                                                                                name="proofOfDeliveryToggle"
                                                                                color="primary"
                                                                            />
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )}

                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                    <div className="pb-5" data-wizard-type="step-content">
                                                        {/*<h4 className="mb-10 font-weight-bold text-dark">Review your Order and Submit</h4>*/}
                                                        {/* <h6 className="font-weight-bolder mb-3">Delivery Address:</h6>
                                                        <div className="text-dark-50 line-height-lg">
                                                            <div>{order.company[0].businessName}</div>
                                                            <div>{order.location[0].locationAddress}</div>
                                                            <div>{order.location[0].locationCity}, {order.location[0].locationZipcode}</div> */}
                                                            {/*<div>Melbourne 3000, VIC, Australia</div>*/}
                                                        {/* </div> */}
                                                        {/* <div className="separator separator-dashed my-5"></div> */}

                                                        {/* <h6 className="font-weight-bolder mb-3">Order Details:</h6>
                                                        <div>{order.supplier[0].entityName}</div> */}
                                                        <div className="text-dark-50 line-height-lg">
                                                            <div className="table-responsive">
                                                                <table className="table">
                                                                    <thead>
                                                                        <tr className='border-bottom'>
                                                                            <th className="pl-0 font-weight-bold text-muted text-uppercase">Ordered
                                                                                Items
                                                                            </th>
                                                                            {/* <th className="text-center font-weight-bold text-muted text-uppercase">SKU</th> */}
                                                                            <th className="text-center font-weight-bold text-muted text-uppercase">Unit
                                                                                Price
                                                                            </th>
                                                                            {
                                                                                order.products.some(p => !p.isExternal) && !isExternalBuyer(user) ?
                                                                                    <th className="text-center font-weight-bold text-muted text-uppercase">{getInventoryColumnLabel()}</th>
                                                                                :
                                                                                    <th className="text-center font-weight-bold text-muted text-uppercase"></th>
                                                                            }
                                                                            <th className="text-center font-weight-bold text-muted text-uppercase">Qty To Order</th>
                                                                            <th className="text-center font-weight-bold text-muted text-uppercase">UoM</th>
                                                                            {
                                                                                currentOrderField.shipVia == "HOME" ? 
                                                                                    <th className="text-center font-weight-bold text-muted text-uppercase">
                                                                                        Catch Weight
                                                                                    </th>
                                                                                :
                                                                                    null
                                                                            }
                                                                            <th className="text-center font-weight-bold text-muted text-uppercase">Total
                                                                                Amount
                                                                            </th>
                                                                            
                                                                            
                                                                            <th className="text-right pr-0 font-weight-bold text-muted text-uppercase">Remove</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                    {order.products.map(product => (
                                                                        <tr className="font-weight-boldest border-bottom-0">
                                                                            <td className="border-top-0 pl-0 py-2 align-items-center">
                                                                                {/* <div className="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                                                                                    <div className="symbol-label"
                                                                                        style={{backgroundImage: "url(" + product.imagePath + ")"}}></div>
                                                                                </div> */}
                                                                                
                                                                                <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                    {product.name}
                                                                                </span>
                                                                                {product.itemNumber && (
                                                                                    <span className="text-muted font-weight-bold d-block text-center">
                                                                                        {product.itemNumber}
                                                                                    </span>
                                                                                )}
                                                                                <span className="text-muted font-weight-bold d-block text-center">
                                                                                    {product.sku}
                                                                                </span>
                                                                            </td>
                                                                            {/* <td className="border-top-0 text-center py-2 align-items-center">
                                                                                {product.sku}
                                                                            </td> */}
                                                                            
                                                                            <td className="border-top-0 text-right py-2 align-middle">
                                                                                {/* FOB display for non-external roles */}
                                                                                
                                                                                {user.tenant === process.env.REACT_APP_PEPEGANGA_TENANT || isBuyerPriceEditLocked(order.supplier && order.supplier[0]) ? (
                                                                                    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                                                                        ${getProductPrice(product)}
                                                                                    </span>
                                                                                ) : (
                                                                                    <NumberInput
                                                                                        value={getProductPrice(product)}
                                                                                        onChange={(e) => handlePriceChange(order._id, product._id, e.target.value)}
                                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                                        min="0"
                                                                                        style={{minWidth:"125px"}}
                                                                                        disabled={!canEditOrder(order)}
                                                                                    />
                                                                                )}
                                                                                {/* Only show FOB for regular users if supplier.isExternal is NOT false */}
                                                                                {!user.roles.includes("buyer_external") && product.fob && order.supplier && order.supplier[0] && order.supplier[0].isExternal !== false && (
                                                                                    <div className="text-muted font-size-sm mt-1">
                                                                                        FOB: ${product.fob}
                                                                                    </div>
                                                                                )}
                                                                                {/* Show discount price for regular users when supplier is not external */}
                                                                                {!user.roles.includes("buyer_external") && order.supplier && order.supplier[0] && order.supplier[0].isExternal === false && product.discountPrice && (
                                                                                    <div className="text-muted font-size-sm mt-1">
                                                                                        Discount Price: ${product.discountPrice}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            {
                                                                                (() => {
                                                                                    const stockQty = getInventoryQty(product, user);
                                                                                    return !product.isExternal && stockQty !== null
                                                                                        ? <td className="border-top-0 text-center py-2 align-items-center">{stockQty}</td>
                                                                                        : <td className="border-top-0 text-center py-2 align-items-center"></td>;
                                                                                })()
                                                                            }
                                                                            <td className="border-top-0 text-center py-2 align-items-center" style={{minWidth:"125px"}}>
                                                                                <div className="align-middle">
                                                                                    <button 
                                                                                        className="btn btn-xs btn-light-primary btn-icon mr-2" 
                                                                                        disabled={product.amount === 0 || !canEditOrder(order)} 
                                                                                        onClick={() => {
                                                                                            handleProductAmountChange(order._id, product._id, product.amount - 1)
                                                                                        }}>
                                                                                        <i className="ki ki-minus icon-xs"></i>
                                                                                    </button>
                                                                                    <span className="mr-2 font-weight-bolder align-middle">{product.amount}</span>
                                                                                    <button 
                                                                                        className="btn btn-xs btn-light-primary btn-icon mr-2" 
                                                                                        disabled={!canEditOrder(order)}
                                                                                        onClick={() => {
                                                                                            handleProductAmountChange(order._id, product._id, product.amount + 1)
                                                                                        }} >
                                                                                        <i className="ki ki-plus icon-xs"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                            <td className="border-top-0 text-center py-2 align-middle">
                                                                                {hasMultipleUnits(product) ? (
                                                                                    <div className="form-group fv-plugins-icon-container align-middle">
                                                                                        <Select
                                                                                            value={product.selectedUnit ? product.selectedUnit.uomId : product.defaultUnitOfMeasurement.uomId}
                                                                                            onChange={(e) => handleProductUnitChange(order._id, product._id, e.target.value)}
                                                                                            disabled={!canEditOrder(order)}
                                                                                            input={
                                                                                                <FilledInput
                                                                                                name={`product-${product.selectedUnit ? product.selectedUnit.uomId : product.defaultUnitOfMeasurement.uomId}`}
                                                                                                id={`product-${product.selectedUnit ? product.selectedUnit.uomId : product.defaultUnitOfMeasurement.uomId}`}
                                                                                                className="form-control form-control-solid h-2 py-2 px-6 align-middle"
                                                                                                disabled={!canEditOrder(order)}
                                                                                                />
                                                                                            }
                                                                                            >
                                                                                            {product.unitsOfMeasurement.map(uom => (
                                                                                                <MenuItem key={uom.uomId} value={uom.uomId}>
                                                                                                    {`${uom.name} (${uom.conversionFactor})`}
                                                                                                </MenuItem>
                                                                                            ))}
                                                                                        </Select>
                                                                                    </div>
                                                                                ) : (
                                                                                    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                                                                        {product.selectedUnit ? `${product.selectedUnit.name} (${product.selectedUnit.conversionFactor})` : `${product.defaultUnitOfMeasurement.name} (${product.defaultUnitOfMeasurement.conversionFactor})`}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                            
                                                                            {
                                                                                currentOrderField.shipVia == "HOME" ? 
                                                                                    product.isCatchWeight ?
                                                                                        <td className="border-top-0 text-center d-flex justify-content-center">
                                                                                            <IconButton  
                                                                                                onClick={() => handleCatchWeightClick(order._id, product._id)}
                                                                                                disabled={!canEditOrder(order)}
                                                                                            >
                                                                                                <span className={`center svg-icon svg-icon-md ${product.amount == product.catchWeights?.length ? "svg-icon-success" : "svg-icon-danger"}`}>
                                                                                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box1.svg")} />
                                                                                                </span>
                                                                                            </IconButton>
                                                                                        </td>
                                                                                        :
                                                                                        <span className="text-dark-75 font-weight-bolder d-block text-center font-size-lg">
                                                                                            {"N/A"}
                                                                                        </span>
                                                                                    :
                                                                                    null
                                                                            }
                                                                            <td className="border-top-0 text-center py-2 align-items-center">
                                                                                {(() => {
                                                                                    const productPrice = getProductPrice(product)
                                                                                    if(product.isCatchWeight) {
                                                                                        return "$" + (productPrice * (product?.catchWeights?.length > 0 ? product?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0)).toFixed(2)
                                                                                    } else {
                                                                                        return "$" + (productPrice * product.amount * (product.selectedUnit ? product.selectedUnit.conversionFactor : 1)).toFixed(2)
                                                                                    }
                                                                                })()}
                                                                            </td>
                                                                            
                                                                            <td className="border-top-0 text-right py-2 align-middle">
                                                                                <InputAdornment position="end">
                                                                                    <IconButton  
                                                                                        onClick={() => handleRemove(order._id, product._id)}
                                                                                        disabled={!canEditOrder(order)}
                                                                                    >
                                                                                    <span  className="center svg-icon svg-icon-md svg-icon-primary">
                                                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                                                                                    </span>
                                                                                    </IconButton>
                                                                                </InputAdornment>
                                                                            </td>
                                                                            {/*<td className="text-primary border-top-0 pr-0 py-4 text-right align-middle">$449.00</td>*/}
                                                                        </tr>
                                                                    ))}
                                                                        <tr className="font-weight-boldest border-bottom-0">
                                                                            <td className="pl-0 py-4 d-flex align-items-center">Total</td>
                                                                            <td ></td>
                                                                            <td ></td>
                                                                            <td className="text-center py-4 align-middle">{order.totalProductQty}</td>
                                                                            <td ></td>
                                                                            <td ></td>
                                                                            <td className="text-center py-4 align-middle">
                                                                                {onlinePaymentEnabled && getPaymentSummary(order) ? (
                                                                                    <PaymentTaxBreakdown summary={getPaymentSummary(order)} />
                                                                                ) : (
                                                                                    `$${order.totalCost}`
                                                                                )}
                                                                            </td>
                                                                            <td ></td>

                                                                        </tr>
                                                                    {/*<tr className='border-top'>*/}
                                                                    {/*    <td colSpan="2"></td>*/}
                                                                    {/*    <td className="font-weight-bolder text-right">Subtotal</td>*/}
                                                                    {/*    <td className="font-weight-bolder text-right pr-0">$1538.00</td>*/}
                                                                    {/*</tr>*/}
                                                                    {/*<tr>*/}
                                                                    {/*    <td colSpan="2" className="border-0 pt-0"></td>*/}
                                                                    {/*    <td className="border-0 pt-0 font-weight-bolder text-right">Delivery*/}
                                                                    {/*        Fees*/}
                                                                    {/*    </td>*/}
                                                                    {/*    <td className="border-0 pt-0 font-weight-bolder text-right pr-0">$15.00</td>*/}
                                                                    {/*</tr>*/}
                                                                    {/*<tr>*/}
                                                                    {/*    <td colSpan="2" className="border-0 pt-0"></td>*/}
                                                                    {/*    <td className="border-0 pt-0 font-weight-bolder font-size-h5 text-right">Grand*/}
                                                                    {/*        Total*/}
                                                                    {/*    </td>*/}
                                                                    {/*    <td className="border-0 pt-0 font-weight-bolder font-size-h5 text-success text-right pr-0">$1553.00</td>*/}
                                                                    {/*</tr>*/}
                                                                    </tbody>
                                                                </table>

                                                            </div>
                                                        </div>
                                                        {/*<div className="separator separator-dashed my-5"></div>*/}
                                                        {/*<h6 className="font-weight-bolder mb-3">Delivery Service Type:</h6>*/}
                                                        {/*<div className="text-dark-50 line-height-lg">*/}
                                                        {/*    <div>Overnight Delivery with Regular Packaging</div>*/}
                                                        {/*    <div>Preferred Morning (8:00AM - 11:00AM) Delivery</div>*/}
                                                        {/*</div>*/}
                                                        {!user.roles.includes("buyer_creator") && (
                                                            <div className="w-100">
                                                                <div className="row justify-content-between">
                                                                    {isPaymentControlsReady ? (
                                                                        <>
                                                                            {orderPaymentStatus?.hideCartActions ? (
                                                                                <div className="ml-5 pr-8">
                                                                                    <span className="text-warning font-weight-bold d-block">
                                                                                        {orderPaymentStatus?.message}
                                                                                    </span>
                                                                                </div>
                                                                            ) : (
                                                                                <>
                                                                                    {orderPaymentStatus?.paymentStatus === 'initiated' ? (
                                                                                        <div className="d-flex flex-wrap align-items-center ml-5">
                                                                                            <button type="button" className="btn btn-outline-warning font-weight-bolder text-uppercase px-9 py-4 ml-2"
                                                                                                onClick={() => setResetPaymentOrderId(order._id)}>
                                                                                                Reset Payment
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : orderPaymentStatus?.isPayable ? (
                                                                                        <div className="d-flex flex-wrap">
                                                                                            <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                                                                onClick={() => handlePayClick(order)}
                                                                                                disabled={isPayAndSubmitDisabled}>
                                                                                                {payInProgressByOrderId[order._id] ? 'Processing...' : 'Pay & Submit'}
                                                                                            </button>
                                                                                            <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                                                                onClick={() => handlePayOnDeliveryClick(order)}
                                                                                                disabled={isPayAndSubmitDisabled}>
                                                                                                Pay on Delivery
                                                                                            </button>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <div className="d-flex flex-wrap">
                                                                                            <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                                                                data-wizard-type="action-submit"
                                                                                                disabled={isStandardSubmitDisabled}
                                                                                                onClick={() =>{
                                                                                                    handleSubmitSingleOrder(order, "Submitted");
                                                                                                }}>Submit
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                    {
                                                                                        user.tenant == process.env.REACT_APP_WAHMEY_TENANT || mustUsePaymentFlow ?
                                                                                            null
                                                                                        :
                                                                                            <div className="d-flex">
                                                                                                <button type="button" className="btn btn-info font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                                                                    data-wizard-type="action-submit"
                                                                                                    disabled={isStandardSubmitDisabled}
                                                                                                    onClick={() =>{
                                                                                                        handleSubmitSingleBackOrder(order);
                                                                                                    }}>Submit as Back Order
                                                                                                </button>
                                                                                                <button type="button" className="btn btn-warning font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                                                                    data-wizard-type="action-submit"
                                                                                                    disabled={isStandardSubmitDisabled}
                                                                                                    onClick={() =>{
                                                                                                        handleSubmitSingleQuote(order);
                                                                                                    }}>Submit as Quote
                                                                                                </button>
                                                                                            </div>
                                                                                    }
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                                <div className="ml-5 mt-2 pr-8">
                                                                    {onlinePaymentEnabled && isPaymentStatusLoading && (
                                                                        <span className="text-muted d-block">Loading payment status...</span>
                                                                    )}
                                                                    {onlinePaymentEnabled && !isPaymentStatusLoading && orderPaymentStatusError && (
                                                                        <span className="text-danger d-block">{orderPaymentStatusError}</span>
                                                                    )}
                                                                    {onlinePaymentEnabled && !isPaymentStatusLoading && orderPaymentStatus?.paymentStatus === 'completed' && (
                                                                        <span className="text-success font-weight-bold d-block">Paid</span>
                                                                    )}
                                                                    {onlinePaymentEnabled && !isPaymentStatusLoading && orderPaymentStatus?.paymentStatus === 'initiated' && (
                                                                        <span className="text-warning font-weight-bold d-block">Payment pending. Reset payment to continue.</span>
                                                                    )}
                                                                    {onlinePaymentEnabled && !isPaymentStatusLoading && orderPaymentStatus?.message && !orderPaymentStatus?.isPayable && orderPaymentStatus?.paymentStatus !== 'completed' && orderPaymentStatus?.paymentStatus !== 'initiated' && (
                                                                        <span className="text-muted d-block small">{orderPaymentStatus.message}</span>
                                                                    )}
                                                                    {onlinePaymentEnabled && orderInlinePaymentMessage && (
                                                                        <span className={`d-block small mt-1 ${
                                                                            orderInlinePaymentMessage.variant === 'danger'
                                                                                ? 'text-danger'
                                                                                : orderInlinePaymentMessage.variant === 'warning'
                                                                                    ? 'text-warning'
                                                                                    : 'text-muted'
                                                                        }`}>
                                                                            {orderInlinePaymentMessage.text}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/*<div className="border-bottom w-100"></div>*/}
                                                    
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>
                        )
                    })}
                        
                            <div className="row justify-content-center py-8 px-8 py-md-27 px-md-0">
                                {/* <div className="mr-2">
                                    <button type="button" className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4"
                                            data-wizard-type="action-prev">Previous
                                    </button>
                                </div> */}
                                <div>
                                    <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 mr-5"
                                            data-wizard-type="action-submit"
                                            onClick={() =>{
                                                handleSaveOrders();
                                            }}>Update Cart
                                    </button>

                                    {!user.roles.includes("buyer_creator") && !isAnyOrderPayable && !onlinePaymentEnabled && (
                                        <>
                                            <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                    data-wizard-type="action-submit"
                                                    onClick={() =>{
                                                        handleSubmitSelectedOrders();
                                                    }}>Submit Selected Orders
                                            </button>
                                            
                                            <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                                    data-wizard-type="action-submit"
                                                    onClick={() =>{
                                                        handleSubmitOrder();
                                                    }}>Submit ALL
                                            </button>
                                        </>
                                    )}
                                    {/* <Stripe
                                        stripeKey={ process.env.REACT_APP_STRIPE_PUBLIC }
                                        token={tokenHandler}
                                    >
                                        <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                            data-wizard-type="action-submit"
                                            >Pay & Submit
                                        </button>
                                    </Stripe> */}
                                </div>
                            </div>
                    </div>
                )
            ) : (
                isCartEmpty ?
                    <div className="card card-custom gutter-b">
                        <div className="card-body p-0">
                            <div className="row justify-content-center px-8 py-md-27 px-md-0">
                                <div className="col-md-10">
                                    <div className="col-sm bg-light-primary px-6 py-4 rounded-xl mr-7">
                                        <div className="text-center mb-4">
                                            <span className="card-label font-weight-bolder text-dark text-center font-size-lg">Shopping Cart</span>
                                        </div>
                                        <div className="text-center">
                                            <span className="text-dark-75 mt-3 font-weight-bold font-size-lg">Shopping Cart is empty!</span>
                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                :
                    null
            )}
            
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Order Confirmation"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogMessage}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        OK
                    </Button>
                    { invoice?.shipVia == "HOME" ?
                            <Button onClick={() => handlePrintInvoice()} color="primary" autoFocus>
                                Print Invoice
                            </Button>
                            :
                            null
                    }
                    {
                        user.isBuyerAdmin && currOrder && !user.roles.includes("buyer_creator") ? 
                            <Button onClick={() => handleSubmitSingleOrder(currOrder, "Submitted", true)} color="primary" autoFocus>
                                Force Submit
                            </Button>
                            :
                            null
                    }
                    {
                        user.isBuyerAdmin && invalidSelectedOrders.length < 1 && !isOrdersValid && isSelectedSubmit && !user.roles.includes("buyer_creator") ? 
                            <Button onClick={() => handleSubmitSelectedOrders(true)} color="primary" autoFocus>
                                Force Submit
                            </Button>
                        :
                            null
                    }
                    {
                        user.isBuyerAdmin && invalidSelectedOrders.length < 1 && !isOrdersValid && isAllSubmit && !user.roles.includes("buyer_creator") ? 
                            <Button onClick={() => handleSubmitOrder(true)} color="primary" autoFocus>
                                Force Submit All
                            </Button>
                        :
                            null
                    }

                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openBO}
                    onClose={handleCloseBO}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {messageBO}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    {currOrder ? (
                        <>
                            <Button onClick={handleCloseBO} color="primary" autoFocus>
                                Cancel
                            </Button>
                            <Button onClick={() => handleSubmitSingleOrder(currOrder, currOrderStatus, true)} color="primary" autoFocus>
                                Submit
                            </Button>
                        </>
                    ) : (
                        <Button onClick={handleCloseBO} color="primary" autoFocus>
                            Close
                        </Button>
                    )}
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openCW}
                    onClose={handleCloseCW}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Catch Weight Input"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className="d-flex flex-column text-md-left">
                                <span><span className="mb-1 font-weight-bolder">Product: </span> {catchWeightProduct?.name}</span>
                                <span><span className="mb-1 font-weight-bolder">Sku: </span> {catchWeightProduct?.sku}</span>
                                <span><span className="mb-1 font-weight-bolder">Left to Add: </span> {(catchWeightProduct?.amount - (catchWeightProduct?.catchWeights?.length ? catchWeightProduct?.catchWeights?.length : 0))}</span>
                            </div>
                        </DialogContentText>   

                        Weight: { (catchWeightProduct?.catchWeights.length > 0 ? catchWeightProduct?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0).toFixed(2)}
                        <div className="row justify-content-between py-8 px-20 py-md-10 px-md-0">
                            <div className="d-flex">
                                <NumberInput
                                    value={catchWeight}
                                    onChange={(e) => setCatchWeight(Number(e.target.value))}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleAddCatchWeight()
                                        }
                                    }}
                                    className={`form-control form-control-solid h-auto py-2 px-6`}
                                    min="0"
                                    style={{minWidth:"125px"}}
                                />
                                <Button onClick={() => handleAddCatchWeight()} color="primary" autoFocus>
                                    Add
                                </Button>
                            </div>
                        </div>
                        
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr className='border-bottom'>
                                        <th className="text-center font-weight-bold text-muted text-uppercase">Product</th>
                                        <th className="text-center font-weight-bold text-muted text-uppercase">Weight</th>
                                        <th className="text-center font-weight-bold text-muted text-uppercase">Remove </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {   catchWeightProduct && catchWeightProduct.catchWeights?
                                            catchWeightProduct.catchWeights.map(cw => (
                                                <tr className="font-weight-boldest border-bottom-0">
                                                    <td className="border-top-0 text-center py-2 align-items-center">
                                                        {catchWeightProduct?.name + " (" + catchWeightProduct?.sku + ")"}
                                                    </td>
                                                    <td className="border-top-0 text-center py-2 align-items-center">
                                                        {cw}
                                                    </td>
                                                    <td className="border-top-0 text-center py-2 align-items-center">
                                                        <InputAdornment position="end">
                                                            <IconButton  onClick={() => handleRemoveCatchWeight(cw)}
                                                            >
                                                            <span  className="center svg-icon svg-icon-md svg-icon-primary">
                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                                                            </span>
                                                            </IconButton>
                                                        </InputAdornment>
                                                    </td>
                                                </tr>
                                            ))
                                        :
                                        null
                                    }
                                </tbody>
                            </table>

                        </div>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={handleCloseCW} color="primary" autoFocus>
                        Close
                    </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={!!resetPaymentOrderId}
                    onClose={() => setResetPaymentOrderId(null)}
                    aria-labelledby="reset-payment-dialog-title"
                    aria-describedby="reset-payment-dialog-description"
                >
                    <DialogTitle id="reset-payment-dialog-title">{"Reset Payment"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="reset-payment-dialog-description">
                            Are you sure you want to reset this payment? Only do this if you did NOT complete the payment in the other tab. If the payment was already processed, resetting may cause it to not be recorded.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setResetPaymentOrderId(null)} color="primary" disabled={resetPaymentLoading}>
                            Cancel
                        </Button>
                        <Button onClick={handleResetPaymentConfirm} color="secondary" disabled={resetPaymentLoading}>
                            {resetPaymentLoading ? 'Resetting...' : 'Reset Payment'}
                        </Button>
                    </DialogActions>
                </Dialog>
        </>

    );
}

export default injectIntl(ConfirmationPage);